<template>
  <ValidationProvider :vid="vid" :name="($attrs.label ? $attrs.label : $attrs.name)" :rules="rules"
                      v-slot="{ valid, errors }">
    <b-form-group v-bind="$attrs">
      <b-form-input
        v-model="innerValue"
        v-bind="$attrs"
        :state="errors[0] ? false : (valid ? true : null)"
        :list="'lists'+randomID"
        autocomplete="off"
      ></b-form-input>
      <datalist :id="'lists'+randomID">
        <option v-for="(option, index) in options" :key="index" v-bind:value="option.text">
          {{option.text }}
        </option>
      </datalist>
      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  props: {
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    value: {
      type: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      innerValue: this.value,
      randomID: Math.floor(Math.random() * (100 - 1 + 1)) + 1
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue (newVal) {
      let source = null
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].text === newVal) {
          source = this.options[i]
          this.innerValue = source.text
        }
      }
      if (source) {
        this.$emit('dataChanged', { value: source.value, text: source.text })
      } else {
        this.innerValue = newVal
        this.$emit('dataChanged', { value: '', text: newVal })
      }
    },
    // Handles external model changes.
    value (newVal) {
      this.innerValue = newVal
    }
  },
  created () {
    if (this.value) {
      this.innerValue = this.value
    }
  }
}
</script>
